module.exports = __webpack_public_path__ + "img/warning.38a4c3da.png";